import { Img } from '@alfa-bank/site-img';
import { ShieldAlfaMIcon } from '@alfalab/icons-site/ShieldAlfaMIcon';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TDefaultIcon, IDeps } from './models';
import { DefaultIcon as Component } from './default-icon';

export const DefaultIcon = createWidget<IDeps, TDefaultIcon>({
    Img,
    ShieldAlfaMIcon,
})(Component);
